import React, { useState, useContext, useEffect } from "react";
import { Paper, Container, Typography } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import { AppContext, DispatchContext } from "../../AppContext";
import { useParams } from "react-router-dom";
import * as actions from "../../actions/actions";
import Service from "../../services/service";
import LanguageMenu from "../../components/LanguageMenu";
import PlagAwareLogo from '../../assets/plagaware-logo-lightblue-150.png';
import IconLabel from '../../components/IconLabel';
import FingerprintIcon from '@material-ui/icons/Fingerprint';
import { config } from '../../helpers/constants';






const useStyles = makeStyles((theme) => ({
  root: displayProps => ({
    height: "100vh",
    background: (displayProps.type == "flat") ? "white" : theme.palette.background.image,
    backgroundSize: 'cover',
    padding: theme.spacing(3),
  }),
  container: {
    height: "100%",
  },
  paper: {
    height: "100%",
    padding: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    position: "relative",
    zIndex: 50,
  },
  header: {
    flex: "0 0 auto",
    marginBottom: 16
  },
  text: {
    height: "100%",
    width: "100%",
    overflowY: "auto",
    overflowX: "hidden",
    paddingRight: 10,
    wordBreak: "break-word",
    whiteSpace: "pre-line"
  },
  error: {
    flex: "0 0 auto",
    alignSelf: "center",
    justifySelf: "center",
  },
  langSelect: {
    position: "absolute",
    top: "20px",
    right: "20px"
  },
  logo: {
    position: "absolute",
    top: "20px",
    left: "20px"
  },
}));

export default function Libtext(props) {
  const dispatch = useContext(DispatchContext);
  const state = useContext(AppContext);
  const s = state.strings;
  let { id, type } = useParams();
  const classes = useStyles({ type });

  const [loading, setLoading] = useState(true);
  const [noAccess, setNoAccess] = useState(false);


  useEffect(() => {

    if (!state.user.loggedIn) {
      return;
    }

    Service.getLibrary(id, true).then(res => {
      setLoading(false);
      if (res.success) {
        dispatch(actions.get_library(res.data || []));
      } else {
        setNoAccess(true);
      }
    });
  }, []);

  if (!state.user.loggedIn) {
    dispatch(actions.navigate_to("/login"));
    return null;
  }

  return (
    <div className={classes.root}>
      <div className={classes.langSelect}>
        <LanguageMenu />
      </div>
      <div className={classes.logo}>
        <img src={PlagAwareLogo} />
      </div>

      <Container maxWidth="md" className={classes.container}>
        <Paper elevation={(type == "flat") ? 0 : 3} className={classes.paper}>
          {noAccess ?
            <div className={classes.error}>
              <Typography align="center" variant="h5" color="error" paragraph>{s.libraryText.noAccessHeading}</Typography>
              <Typography align="center" variant="body1" paragraph>{s.libraryText.noAccessDesc}</Typography>
            </div>
            :
            <>
              {!loading && state.activeLibrary &&
                <>
                  <div className={classes.header}>
                    <Typography variant="h5" color="primary" paragraph noWrap>{state.activeLibrary.Name}</Typography>
                    <Typography variant="body2" color="primary">{s.libraryText.author}: {state.activeLibrary.Author || s.common.na}</Typography>
                    <Typography variant="body2" color="primary">{s.libraryText.owner.format(state.activeLibrary.Owner, state.activeLibrary.Date)}</Typography>
                    <Typography variant="body2" color="primary">{s.libraryText.words.format(state.activeLibrary.Words, state.activeLibrary.Pages)}</Typography>
                    <Typography variant="body2" color="primary">{s.libraryText.description}: {state.activeLibrary.Comment || s.common.na}</Typography>
                    {state.activeLibrary.IsFingerprint && config.mode == "PROD" && <IconLabel centered spacing={64} icon={<FingerprintIcon fontSize="large" />} label={s.libraryText.isFingerprint} />}
                  </div>
                  <div className={classes.text}>{(state.activeLibrary.IsFingerprint && config.mode == "PROD")  ? "" : state.activeLibrary.Text}</div>
                </>
              }
            </>
          }

        </Paper>
      </Container>
    </div>
  );
}
